export enum FieldWrapperType {
  CHECKLIST = "checklist",
  APPLICATION = "application",
  DUE_DILIGENCE_EDIT_PREVIEW = "due_diligence_edit_preview",
}
